<!--
 * @Descripttion: 小区管理
 * @version: 
 * @Author: alex.yang
 * @Date: 2022-07-13 09:49:12
 * @LastEditors: alex.yang
 * @LastEditTime: 2022-07-29 10:14:26
-->
<template>
    <div class="communityManagement">
        <div class="add-wrap">
            <div class="search-wrap">
                <el-input clearable v-model="keyword" placeholder="请输入搜索内容"></el-input>
                <el-button @click="clickSearch" type="primary">搜索</el-button>
            </div>
            <el-button @click="clickShowScene" class="btns" type="primary">添加小区</el-button>
        </div>
        <div class="table-wrap" v-loading="loading">
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column align="center" prop="id" label="ID" width="60"></el-table-column>
                <el-table-column align="center" prop="cover" label="图片" width="80">
                    <template slot-scope="scope">
                        <img :src="scope.row.cover" height="30" />
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="name" label="小区名称"></el-table-column>
                <el-table-column align="center" prop="design_room_count" label="小区户型数"></el-table-column>
                <el-table-column align="center" prop="design_case_count" label="小区案例数" ></el-table-column>
                <el-table-column align="center" prop="create_timex" label="创建时间" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column align="center" label="操作" width="150">
                    <template slot-scope="scope">
                        <div class="operation-wrap">
                            <template v-if="scope.row.main_push === 1">
                              <el-tooltip class="item" effect="dark" content="取消主推小区" placement="top">
                                <i @click="mainPush(scope.row)" class="iconfont el-icon-star-on"></i>
                              </el-tooltip>
                            </template>
                            <template v-else>
                              <el-tooltip class="item" effect="dark" content="主推小区" placement="top">
                                <i @click="mainPush(scope.row)" class="iconfont el-icon-star-off"></i>
                              </el-tooltip>
                            </template>
                            <el-tooltip class="item" effect="dark" content="查看户型" placement="top">
                                <i @click="clickFamily(scope.row)" class="iconfont el-icon-school"></i>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                                <i @click="clickEdit(scope.row)" class="iconfont el-icon-edit"></i>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="删除" placement="top">
                                <i @click="clickDelete(scope.row)" class="iconfont el-icon-delete"></i>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-size="10"
                    layout="total, prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog
            :visible.sync="isShowScene" 
            @close="handleClose"
            custom-class="dialog-wrap"
            :close-on-click-modal="false">
            <div class="title" v-if="editId<0">添加小区</div>
            <div class="title" v-else>编辑小区</div>
            <div class="content" v-loading="dialogLoading">
                <el-form :model="plotForm" :rules="plotRules" ref="plotForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="小区名称" prop="name">
                        <el-input v-model="plotForm.name" placeholder="请输入小区名称"></el-input>
                    </el-form-item>
                    <el-form-item label="图片" prop="cover">
                        <div class="upload-wrap">
                            <aliyun-upload 
                                :limitSize="8" :limit="1" :isShopTip="false"
                                :btnDisplay="image.length<1" listType="picture-card"
                                v-model="image">
                            </aliyun-upload>
                            <div v-if="image.length>0" class="fileList-box">
                                <div @click="delImageList" class="delFile">x</div>
                                <el-image fit="contain" class="pic"
                                    :preview-src-list="image" :src="image[0]"/>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div class="btn-wrap">
                <el-button v-if="editId<0" :loading="btnLoading" @click="creationPaves" type="primary">添加</el-button>
                <el-button v-else :loading="btnLoading" @click="editPaves" type="primary">编辑</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import common from "@/utils/common.js"
import AliyunUpload from "@/components/upload/AliyunUpload.vue";
export default {
    components:{
        AliyunUpload,
    },
    data () {
        return {
            loading: false,
            dialogLoading: false,
            tableData: [],
            total: 0,
            currentPage: 1,
            isShowScene: false,
            keyword: '',
            epOptions: [],
            shopOptions: [],
            plotForm: {
                name: '',
                cover: '',
            },
            plotRules: {
                name: [
                    { required: true, message: '请输入小区名称', trigger: 'blur' },
                ],
                cover: [
                    { required: true, message: '请上传图片', trigger: 'blur' },
                ],
            },
            image: [],
            btnLoading: false,
            editId: -1
        }
    },
    watch: {
        image(newData, oldData) {
            this.plotForm.cover = newData[0]
        }
    },
    mounted () {
        this.getResidentialIndex();
    },
    methods: {
        clickFamily(row){
            this.$router.push({name:'familyManagement'});
            localStorage.setItem('family',JSON.stringify(row));
        },
        // 创建
        creationPaves(){
            this.$refs.plotForm.validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    common.connect('/distributorpcv1/scene_case/storeBuilding',this.plotForm,(res)=>{
                        if(res.isSuccess == 1){
                            this.getResidentialIndex();
                            this.isShowScene = false;
                            common.connect('/distributorpcv1/log/storeLogShopFunction',{function: 'PC-创建小区'})
                        }
                        this.btnLoading = false;
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 编辑
        editPaves(){
            this.$refs.plotForm.validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.plotForm.id = this.editId;
                    common.connect('/distributorpcv1/scene_case/updateBuilding',this.plotForm,(res)=>{
                        if(res.isSuccess == 1){
                            this.getResidentialIndex();
                            this.isShowScene = false;
                            this.image = [];
                            this.editId = -1;
                            common.connect('/distributorpcv1/log/storeLogShopFunction',{function: 'PC-编辑小区'})
                        }
                        this.btnLoading = false;
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 设置为主推
        mainPush(row) {
          common.connect('/distributorpcv1/scene_case/mainPushBuilding',{id: row.id},(res)=>{
            this.getResidentialIndex();
            common.connect('/distributorpcv1/log/storeLogShopFunction',{function: 'PC-主推小区操作'})
          })
        },
        // 编辑页
        clickEdit(row){
            this.editId = row.id;
            common.connect('/distributorpcv1/scene_case/editBuilding',{id: row.id},(res)=>{
                this.isShowScene = true;
                this.image[0] = res.data.cover;
                this.plotForm = res.data;
                this.getShopConditions();
            })
        },
        // 删除
        clickDelete(row){
            this.$confirm('此操作将永久删除该小区, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                common.connect('/distributorpcv1/scene_case/deleteBuilding',{id: row.id},(res)=>{
                    this.getResidentialIndex();
                    common.connect('/distributorpcv1/log/storeLogShopFunction',{function: 'PC-删除小区'})
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        // 获取小区列表数据
        getResidentialIndex(){
            let params = {
                page: this.currentPage,
                keyword: this.keyword
            }
            this.loading = true;
            common.connect('/distributorpcv1/scene_case/buildingIndex',params,(res)=>{
                this.tableData = res.data.list;
                this.total = res.data.count;
                this.loading = false;
            })
        },
        // 搜索
        clickSearch(){
            this.getResidentialIndex();
        },
        delImageList(){
            this.image.splice(0, 1)
        },
        clickShowScene(){
            this.isShowScene = true;
        },
        // 关闭弹窗
        handleClose(){
            let plotForm = {
                name: '',
                cover: '',
            }
            this.isShowScene = false;
            this.editId = -1;
            this.image = [];
            this.plotForm = plotForm;
        },
        handleCurrentChange(val){
            this.currentPage = val;
            this.getResidentialIndex();
        }
    },
}
</script>

<style lang='scss'>
.communityManagement{
    .add-wrap{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .search-wrap{
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            .el-input{
                width: 200px;
                margin-right: 10px;
            }
        }
    }
    .table-wrap{
        margin-top: 20px;
        .image{
            width: 40px;
            cursor: pointer;
        }
        .operation-wrap{
            display: flex;
            justify-content: center;
            .iconfont{
                font-size: 16px;
                padding: 0 10px;
                cursor: pointer;
            }
        }
        .pagination-wrap{
            display: flex;
            justify-content: flex-end;
            align-items: center;
            padding-top: 20px;
        }
    }
    .dialog-wrap{
        width: 700px;
        .title{
            font-size: 16px;
            color: #000;
            margin-left: 20px;
        }
        .el-select{
            width: 100%;
        }
        .content{
            margin: 40px 20px 20px 20px;
            .upload-wrap{
                padding-top: 2px;
                .fileList-box{
                    width: 100px;
                    height: auto;
                    position: relative;
                    .delFile{
                        position: absolute;
                        top: 5px;
                        left: 5px;
                        cursor: pointer;
                        width: 20px;
                        height: 20px;
                        border-radius: 100%;
                        border: 1px #ddd solid;
                        background: rgba(100, 100, 100, 0.5);
                        color: #fff;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        z-index: 99;
                    }
                    .pic{
                        width: 100%;
                    }
                }
            }
        }
        .btn-wrap{
            display: flex;
            justify-content: center;
            padding: 15px 0;
        }
    }
    .el-dialog{
        margin: 0;
        margin-top: 0vh !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        padding-bottom: 10px;
    }
}
</style>
